module.exports = __webpack_public_path__ + "img/DELIVER.dbd8fa61.png";